"use client";

import { useSyncExternalStore } from "react";

import { Badge } from "@/components/ui/badge";

type DetectableOs = "mac" | "windows";

let cachedOs: DetectableOs | null | undefined;

function getClientOs(): DetectableOs | null {
  if (cachedOs === undefined) {
    const probe = `${navigator.platform} ${navigator.userAgent}`.toLowerCase();
    cachedOs = probe.includes("mac") ? "mac" : probe.includes("win") ? "windows" : null;
  }
  return cachedOs;
}

const subscribeNoop = () => () => {};

/**
 * Renders a small "Your device" badge when the visitor's OS matches `os`.
 * Server-renders nothing and appears on the client, so both OS sections
 * stay equally visible for the no-match / no-JS case (AIR-659: first-time
 * users downloaded the wrong platform's file).
 */
export function DetectedOsBadge({ os }: { os: DetectableOs }) {
  const detected = useSyncExternalStore(subscribeNoop, getClientOs, () => null);

  if (detected !== os) return null;
  return <Badge variant="secondary">Your device</Badge>;
}
